import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { moduleNamespace } from '@Store/config.store';
import { NamespacedStoreState } from '@Types/store.types';
import { DefectCode } from '@Types';

const parseNamespace = (state: NamespacedStoreState) => state[moduleNamespace];

const inspectionTypesStoreSelector = createSelector(parseNamespace, state => state.InspectionTypesStore);

export const allInspectionTypesSelector = createSelector(
	inspectionTypesStoreSelector,
	store => store.inspectionTypeList ?? [],
);

export const eventTypesSelector = createSelector(allInspectionTypesSelector, types => {
	return types.filter(type => type.event === true);
});

export const taskTypesSelector = createSelector(allInspectionTypesSelector, types =>
	types.filter(type => type.task === true),
);

export const inspectionOnlyTypesSelector = createSelector(allInspectionTypesSelector, types =>
	types.filter(type => !type.event && !type.task),
);

export const standardCodeSelector = (standard: string) =>
	createSelector(inspectionTypesStoreSelector, state => state.codesByStandard?.[standard] ?? []);

export const selectEventTypes = () => useSelector(eventTypesSelector);
export const selectTaskTypes = () => useSelector(taskTypesSelector);
export const selectInspectionOnlyTypes = () => useSelector(inspectionOnlyTypesSelector);
export const selectAllInspectionTypes = () => useSelector(allInspectionTypesSelector);
export const selectStandardCodes = (standard: string): DefectCode[] => {
	return useSelector(standardCodeSelector(standard));
};
